<template>
    <div class="step-layout">
        <!-- ---------------------------- Step Intro Section ---------------------------- -->
        <section class="step-layout-left bg-2">
            <div class="step-layout-container">
                <!-- Progressbar -->
                <div class="progressbar">
                    <ul>
                        <li class="completed">Your city {{ selectedCity }}</li>
                        <li class="completed">Contact Details</li>
                        <li class="active">Home Type</li>
                        <li>Other Details</li>
                        <li>Home Details</li>
                    </ul>
                </div>
                <!-- Intro Title -->
                <h2
                    class="text-white intro-title d-none d-sm-block"
                    data-aos="fade-up"
                    data-aos-duration="1300"
                >
                    This question helps us in<br /> giving you a more<br />
                    accurate value.
                </h2>
                <h2
                    class="text-white intro-title d-block d-sm-none text-center"
                    data-aos="zoom-in"
                    data-aos-duration="1300"
                >
                    This question helps us in giving you a more accurate value.
                </h2>
                <!-- Back Button -->
                <div
                    class="text-center text-sm-left"
                    data-aos="fade-up"
                    data-aos-duration="1600"
                >
                    <a
                        href="javascript:void(0)"
                        class="btn btn-primary"
                        @click="goBack()"
                    >
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a>
                </div>
            </div>
        </section>

        <!-- -------------------------- Step Form Section -------------------------- -->
        <section class="step-layout-right">
            <div
                class="step-layout-container"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <h2 class="text-primary title" v-html="valuationTitle"></h2>
                <form class="text-center">
                    <!-- Home Types List Group -->
                    <ul class="list-group list-group-radio">
                        <a
                            href="javascript:void(0)"
                            :class="propertyType == 'Detached' ? 'active' : ''"
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Detached')"
                        >
                            <span class="radio"></span
                            ><span>Detached Home</span>
                        </a>
                        <a
                            href="javascript:void(0)"
                            :class="
                                propertyType == 'Semi-Detached' ? 'active' : ''
                            "
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Semi-Detached')"
                            ><span class="radio"></span
                            ><span>Semi-Detached</span>
                        </a>
                        <a
                            href="javascript:void(0)"
                            :class="
                                propertyType == 'Att/Row/Twnhouse'
                                    ? 'active'
                                    : ''
                            "
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Att/Row/Twnhouse')"
                        >
                            <span class="radio"></span
                            ><span>Att/Row/Townhouse</span>
                        </a>
                        <a
                            href="javascript:void(0)"
                            :class="
                                propertyType == 'Condo Townhouse'
                                    ? 'active'
                                    : ''
                            "
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Condo Townhouse')"
                        >
                            <span class="radio"></span
                            ><span>Condo Townhouse</span>
                        </a>
                        <input type="text" placeholder="Enter Unit Number" v-model="valuation_property_unit" class="pl-3 py-2" v-if="propertyType == 'Condo Townhouse'" />
                        <a
                            href="javascript:void(0)"
                            :class="propertyType == 'Condo Apt' ? 'active' : ''"
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Condo Apt')"
                        >
                            <span class="radio"></span
                            ><span>Condo Apartment</span>
                        </a>
                        <input type="text" placeholder="Enter Unit Number" v-model="valuation_property_unit" class="pl-3 py-2" v-if="propertyType == 'Condo Apt'" />
                        <a
                            href="javascript:void(0)"
                            :class="propertyType == 'Other' ? 'active' : ''"
                            class="list-group-item list-group-item-action"
                            @click="selectHomeType('Other')"
                        >
                            <span class="radio"></span><span>Other</span>
                        </a>
                    </ul>
                    <div class="text-left text-lg-right submit-btn-wrapper" >
                        <button type="button" class="btn btn-primary btn-lg submit-btn" @click="submitForm()">
                            Continue
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "PropertyValuationStepTwo",
    data() {
        return {
            valuationStep: 2,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "Detached",
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Second Step",
            valuationTitle: "What best describes your home?",
            valuation_property_unit: ""
        };
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        //step-1 data
        if(sessionStorage.getItem('valuation_name')) {
            this.name = sessionStorage.getItem('valuation_name');
        }
        if(sessionStorage.getItem('valuation_email')) {
            this.email = sessionStorage.getItem('valuation_email');
        }
        if(sessionStorage.getItem('valuation_phone')) {
            this.phone = sessionStorage.getItem('valuation_phone');
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem("valuation_property_type");
        }
        //other
        if(sessionStorage.getItem('valuation_utm_source')) {
            this.utm_source = sessionStorage.getItem('valuation_utm_source');
        }
        if(sessionStorage.getItem('valuation_utm_medium')) {
            this.utm_medium = sessionStorage.getItem('valuation_utm_medium');
        }
        if(sessionStorage.getItem('valuation_utm_campaign')) {
            this.utm_campaign = sessionStorage.getItem('valuation_utm_campaign');
        }
        if(sessionStorage.getItem('valuation_utm_id')) {
            this.utm_id = sessionStorage.getItem('valuation_utm_id');
        }
        if(sessionStorage.getItem('valuation_utm_content')) {
            this.utm_content = sessionStorage.getItem('valuation_utm_content');
        }
        if(sessionStorage.getItem('valuation_data')) {
            sessionStorage.removeItem('valuation_data');
        }
        if(sessionStorage.getItem('valuation_property_unit')) {
            this.valuation_property_unit = sessionStorage.getItem('valuation_property_unit');
        }
    },
    methods: {
        submitForm() {
            sessionStorage.setItem("valuation_property_type",this.propertyType);
            sessionStorage.setItem("valuation_property_unit",this.valuation_property_unit);
            window.location.href = "/properties/valuation/submit/data/step-4";
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-1";
        },
        selectHomeType(type) {
            this.propertyType = type;
            if(!['Condo Townhouse','Condo Apt'].includes(type)){
                this.valuation_property_unit = ""
                sessionStorage.removeItem('valuation_property_unit');
            }
        },
    },
};
</script>

<style scoped>
    button:disabled {
        cursor: not-allowed;
    }
    .form-control:focus,
    .form-control:active,
    .form-control:visited {
        outline: none;
    }
</style>
